import { Component, Input } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolSpinner, SolSpinnerSize } from '../../../models/core/sol-spinner';
import { TimerTools } from '../../../tools/timer-tools';
import { SolSpinnerState } from './sol-spinner.state';

@Component({
  selector: 'sol-spinner',
  templateUrl: './sol-spinner.component.html',
  host: { '[class]': 'hostClass$()' },
})
export class SolSpinnerComponent extends AbstractComponent<SolSpinnerState> {
  // Static references
  protected readonly ringLength = SolSpinnerState.ringLength;

  // Computed
  protected readonly hostClass$ = this.computeByRef(state => state.hostClass);
  protected readonly countdown$ = this.computeByRef(state => state.spinner.countdown);
  protected readonly segments$ = this.compute(state => state.segments);

  // Actions
  private readonly runClock = this.latestAction((endsAt: Date | undefined) =>
    TimerTools.nowUntil$(endsAt, SolSpinnerState.secondMs).subscribe(now => this.update(state => state.withNow(now))),
  );

  constructor() {
    super(SolSpinnerState.of());
  }

  @Input()
  public set spinner(spinner: SolSpinner) {
    this.update(state => state.withSpinner(spinner, Date.now()));
    this.runClock(spinner.countdown?.endsAt);
  }

  @Input()
  public set size(size: SolSpinnerSize | undefined) {
    this.update(state => state.withSize(size));
  }
}
